import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from '../../../util/mobile-detect';
import { audioPlugins, videoPlugins } from '../../../plugins';
import BNNVARAMediaPlayer from '../BNNVARAMediaPlayer/BNNVARAMediaPlayer';
import NPOVideoPlayer from '../NPOVideoPlayer/NPOVideoPlayer';

export const BNNVARA_VIDEO_PLAYER_TYPE = 'video';
export const NPO_VIDEO_PLAYER_TYPE = 'npo';
export const BNNVARA_AUDIO_PLAYER_TYPE = 'audio';

const MediaPlayer = ({ type, ...playerProps }) => {
  if (
    type === BNNVARA_AUDIO_PLAYER_TYPE ||
    type === BNNVARA_VIDEO_PLAYER_TYPE
  ) {
    const {
      source,
      poster,
      title,
      subtitles,
      genres,
      broadcasters,
      mediaId,
      classifications,
    } = playerProps;

    const searchParams = new URLSearchParams(window.location.search);
    const vertical = !!searchParams.get('vertical');

    return (
      <BNNVARAMediaPlayer
        mediaId={mediaId}
        vertical={vertical}
        source={source}
        poster={poster}
        loadingPosterImage={
          type === BNNVARA_VIDEO_PLAYER_TYPE
            ? '../../assets/placeholder.jpg'
            : null
        }
        isMobile={isMobile()}
        title={title}
        subtitles={subtitles}
        broadcasters={broadcasters}
        plugins={
          type === BNNVARA_AUDIO_PLAYER_TYPE ? audioPlugins : videoPlugins
        }
        genres={genres}
        classifications={classifications}
        type={type === BNNVARA_AUDIO_PLAYER_TYPE ? 'audio' : 'video'}
      />
    );
  }

  if (type === NPO_VIDEO_PLAYER_TYPE) {
    const { embedId, title } = playerProps;

    return <NPOVideoPlayer embedId={embedId} title={title} />;
  }

  return null;
};

MediaPlayer.defaultProps = {
  type: BNNVARA_VIDEO_PLAYER_TYPE,
};

MediaPlayer.propTypes = {
  type: PropTypes.oneOf([
    BNNVARA_VIDEO_PLAYER_TYPE,
    NPO_VIDEO_PLAYER_TYPE,
    BNNVARA_AUDIO_PLAYER_TYPE,
  ]),
};

export default MediaPlayer;
